"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { createClarityLifecycle } from "@/lib/analytics/clarityLifecycle";

/** Records public pages only while analytics consent is granted. */
export function ClarityConsentLoader() {
  const pathname = usePathname();
  // Preserve the router's context identity: hash-only Next navigation updates
  // it even when the serialized query and pathname are unchanged.
  const search = useSearchParams();
  const lifecycle = useRef<ReturnType<typeof createClarityLifecycle> | null>(null);
  useEffect(() => {
    lifecycle.current = createClarityLifecycle();
    return () => { lifecycle.current?.dispose(); lifecycle.current = null; };
  }, []);
  useEffect(() => { lifecycle.current?.sync(); }, [pathname, search]);
  return null;
}
